var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomFont(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30502",
    "data-name": "Group 30502",
    transform: "translate(10709 -17341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30485",
    "data-name": "Group 30485"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14180",
    "data-name": "Rectangle 14180",
    width: 32,
    height: 32,
    transform: "translate(-10709 17341)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30610",
    "data-name": "Group 30610",
    transform: "translate(-10835.999 17022.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50104",
    "data-name": "Path 50104",
    d: "M145.959,340.906h-4.392a1.4,1.4,0,1,1,0-2.807h.756v-6.146h-1.439v.56a1.442,1.442,0,0,1-2.882,0v-1.964a1.425,1.425,0,0,1,1.441-1.4h8.641a1.424,1.424,0,0,1,1.441,1.4v1.964a1.441,1.441,0,0,1-2.881,0v-.56H145.2V338.1h.754a1.4,1.4,0,1,1,0,2.807Zm-4.392-1.918a.515.515,0,1,0,0,1.029h4.392a.515.515,0,1,0,0-1.029h-1.211a.45.45,0,0,1-.456-.445v-7.035a.45.45,0,0,1,.456-.444H147.1a.45.45,0,0,1,.457.444v1.005a.528.528,0,0,0,1.057,0v-1.964a.522.522,0,0,0-.529-.515h-8.641a.522.522,0,0,0-.529.515v1.964a.529.529,0,0,0,1.058,0v-1.005a.45.45,0,0,1,.456-.444h2.352a.45.45,0,0,1,.456.444v7.035a.45.45,0,0,1-.456.445Z",
    transform: "translate(-0.764 -0.64)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50105",
    "data-name": "Path 50105",
    d: "M135.617,341.07a.4.4,0,0,1-.35-.44V329.362a.359.359,0,1,1,.7,0V340.63A.4.4,0,0,1,135.617,341.07Z",
    transform: "translate(-0.305 -0.61)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50106",
    "data-name": "Path 50106",
    d: "M150.5,341.07a.4.4,0,0,1-.35-.44V329.362a.359.359,0,1,1,.7,0V340.63A.4.4,0,0,1,150.5,341.07Z",
    transform: "translate(0.19 -0.61)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50107",
    "data-name": "Path 50107",
    d: "M149.243,327.353H137.975a.359.359,0,1,1,0-.7h11.268a.359.359,0,1,1,0,.7Z",
    transform: "translate(-0.61 -0.305)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50108",
    "data-name": "Path 50108",
    d: "M149.243,342.233H137.975a.359.359,0,1,1,0-.7h11.268a.359.359,0,1,1,0,.7Z",
    transform: "translate(-0.61 0.19)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50109",
    "data-name": "Path 50109",
    d: "M135.312,329.011a2.313,2.313,0,1,1,2.313-2.313A2.316,2.316,0,0,1,135.312,329.011Zm0-3.925a1.612,1.612,0,1,0,1.612,1.612A1.614,1.614,0,0,0,135.312,325.086Z",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50110",
    "data-name": "Path 50110",
    d: "M135.312,343.891a2.313,2.313,0,1,1,2.313-2.314A2.316,2.316,0,0,1,135.312,343.891Zm0-3.926a1.613,1.613,0,1,0,1.612,1.612A1.615,1.615,0,0,0,135.312,339.965Z",
    transform: "translate(0 0.495)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50111",
    "data-name": "Path 50111",
    d: "M150.191,329.011A2.313,2.313,0,1,1,152.5,326.7,2.316,2.316,0,0,1,150.191,329.011Zm0-3.925A1.612,1.612,0,1,0,151.8,326.7,1.614,1.614,0,0,0,150.191,325.086Z",
    transform: "translate(0.495)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50112",
    "data-name": "Path 50112",
    d: "M150.191,343.891a2.313,2.313,0,1,1,2.313-2.314A2.316,2.316,0,0,1,150.191,343.891Zm0-3.926a1.613,1.613,0,1,0,1.613,1.612A1.615,1.615,0,0,0,150.191,339.965Z",
    transform: "translate(0.495 0.495)",
    fill: "#8a8a8a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFont);
export default __webpack_public_path__ + "static/media/customFont.50fcf5fa.svg";
export { ForwardRef as ReactComponent };